import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-forward-svg',
  templateUrl: './forward-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class ForwardSvgComponent {}
